@if (!universalService.isMobileDevice) {
  <div class="modal fade" id="duplicate-folder-modal" role="dialog" tabindex="-1" aria-hidden="true" [ngStyle]="{'display': 'block','opacity': 1, 'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content h-90">
        <div class="modal-header">
          <button type="button" class="close btn-pos" data-dismiss="modal" (click)="close()">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
          <h5 class="mb-0">Upload Options</h5>
        </div>
        <div class="modal-body border-bottom-0">
          <div class="duplicate-folder-confimation mt-2">
            <p class="text" style="margin-bottom: 0;"><strong>{{uploadQueueImplRef.uploadQueue[currentFolderIndex].newName}}</strong> already exists in this location. </p>
            <p class="text">Do you want to merge into the existing folder or keep both the folders. Merging folders won't change the sharing setting. </p>
          </div>
          <div class="upload-options">
            <div class="option" (click)="changeSelection('merge')">
              <input type="radio" class="radio-button" id="radio-button-1" name="radio-button">
              <label for="radio-button-1" class="radio-text"> Merge into existing folder</label>
            </div>
            <div class="option"  (click)="changeSelection('createNew')">
              <input type="radio" class="radio-button" id="radio-button-2" name="radio-button" checked>
              <label for="radio-button-2" class="radio-text"> Keep both folders</label>
            </div>
          </div>
        </div>
        <div class="modal-footer pt-2">
          <!-- Button -->
          <div class="btn-wrap">
            <button class="btn btn-duplicate-folder-cancel mr-md-5 mb-3 mb-md-0" title="Cancel" id="btn-duplicate-folder-cancel" (click)="close()">Cancel</button>
            <button class="btn btn-duplicate-folder-upload" id="btn-duplicate-folder-upload" title="Upload" data-dismiss="modal" (click)="upload()">Upload</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (universalService.isMobileDevice) {
  <div class="modal fade slide-in-fwd-center" id="m-duplicate-folder-modal" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="m-folder-not-supported-modal" aria-hidden="true" [ngStyle]="{'display':'block', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog" role="document">
      <div class="modal-content animated bounceInUp fixed-bottom">
        <div class="modal-header">
          <h6>Upload Options</h6>
        </div>
        <div class="modal-body border-bottom-0">
          <div class="duplicate-folder-confimation">
            <p class="text" style="margin-bottom: 0;"><strong>{{uploadQueueImplRef.uploadQueue[currentFolderIndex].newName}}</strong> already exists in this location. </p>
            <p class="text">Do you want to merge into the existing folder or keep both the folders. Merging folders won't change the sharing setting. </p>
          </div>
          <div class="upload-options">
            <div class="option" (click)="changeSelection('merge')">
              <input type="radio" class="radio-button" id="radio-button-1" name="radio-button">
              <label for="radio-button-1" class="radio-text"> Merge into existing folder</label>
            </div>
            <div class="option"  (click)="changeSelection('createNew')">
              <input type="radio" class="radio-button" id="radio-button-2" name="radio-button">
              <label for="radio-button-2" class="radio-text"> Keep both folders</label>
            </div>
          </div>
        </div>
        <div class="modal-footer pt-2">
          <!-- Button -->
          <div class="btn-wrap">
            <button class="btn btn-duplicate-folder-cancel mr-md-5 mb-3 mb-md-0" title="Cancel" id="btn-duplicate-folder-cancel" (click)="close()">Cancel</button>
            <button class="btn btn-duplicate-folder-upload" id="btn-duplicate-folder-upload" title="Upload" data-dismiss="modal" (click)="upload()">Upload</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}